export default {
  data() {
    return {
      lazyLoadObserver: null,
    }
  },
  methods: {
    lazyLoad: function(dom, handler, iOptions={
      root: null,
      rootMargin: '0px',
      threshold: 0,
      keepAlive: false
    }) {
      if (dom && "IntersectionObserver" in window) {
        this.lazyLoadObserver = new IntersectionObserver((entries, options) => {
          let {isIntersecting} = entries[0];
          if (isIntersecting) {
            handler();
            !iOptions.keepAlive && this.lazyLoadObserver.unobserve(dom);
          }
        }, iOptions);
        this.lazyLoadObserver.observe(dom);
      } else {
        handler();
      }
    }
  },
  beforeDestroy() {
    this.lazyLoadObserver && this.lazyLoadObserver.disconnect();
  },
}